import * as React from 'react';
import { connect } from 'react-redux';
import { getFrontSheetData } from './redux-objects/actions';
import { Button } from 'react-bootstrap';
import { getFrontSheet } from '../../services/documentDownloadService';

const initialState = { redactedOnly: false, isGenerating: false };

export interface IFrontSheetDataActionProps {
  getFrontSheetData?: (url: string, reportId: any) => Promise<any>;
}

export interface IPrintPDFPropsFromState {
  webServiceURL: string;
  frontSheetData: any[];
}

export interface IPrintPDFProps
  extends IFrontSheetDataActionProps,
  IPrintPDFPropsFromState { }

class PrintPDF extends React.Component<IPrintPDFProps, any> {
  public constructor(props: IPrintPDFPropsFromState) {
    super(props);
    this.state = {
      printDuration: '',
      reportId: null,
      initialState,
    };

    this.getOnlinePDF = this.getOnlinePDF.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange({ target }) {
    this.setState({
      [target.name]: target.value,
    });
  }

  getOnlinePDF = async () => {
    this.setState({ isGenerating: true, printDuration: '' });
    const reportId = parseInt(this.state.reportId);
    getFrontSheet(reportId);
  };

  render() {
    return (
      <div>
        <div>
          <input
            type='text'
            name='reportId'
            placeholder='Enter a Report Id...'
            value={this.state.reportId}
            onChange={this.handleChange}
          />{' '}
          <Button
            value='Send'
            disabled={this.state.isGenerating}
            onClick={this.getOnlinePDF}
          >
            {this.state.isGenerating && (
              <div>
                Printing Report{'   '}
                <img
                  src={require('../../../src/assets/SmartAdmin/img/loading.gif')}
                  alt={''}
                />
              </div>
            )}
            {!this.state.isGenerating && <div>Print NDOT Front Sheet</div>}
          </Button>
          {this.state.printDuration != '' ? (
            <div>Time to generate: {this.state.printDuration}</div>
          ) : null}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (reduxState: any) => {
  return {
    webServiceURL: reduxState.Application.backendURL,
  };
};

const mapDispatchToProps = {
  getFrontSheetData,
};

export default connect<IPrintPDFPropsFromState, any>(
  mapStateToProps,
  mapDispatchToProps
)(PrintPDF);
